import { FC } from 'react';
import {
  StyledBoxSubtitle,
  StyledSubtitleLabelSection,
  StyledSubtitleLabel,
  StyledSubtitleNumber,
  StyledSubtitleLabel2,
} from '../SectionSubtitle/SectionSubtitle.styles';
import { CampaignTitleCardProps } from './CampaignTitleCard.types';

const CampaignTitleCard: FC<CampaignTitleCardProps> = ({ title, subtitle, parenthesisSubtitle, value }) => {
  return (
    <StyledBoxSubtitle>
      <StyledSubtitleLabelSection>
        <StyledSubtitleLabel>
          {title}
          {!subtitle && parenthesisSubtitle && <StyledSubtitleLabel2>({parenthesisSubtitle})</StyledSubtitleLabel2>}
        </StyledSubtitleLabel>
        <StyledSubtitleLabel>
          {subtitle}
          {subtitle && parenthesisSubtitle && <StyledSubtitleLabel2>({parenthesisSubtitle})</StyledSubtitleLabel2>}
        </StyledSubtitleLabel>
      </StyledSubtitleLabelSection>
      <StyledSubtitleNumber>{value}</StyledSubtitleNumber>
    </StyledBoxSubtitle>
  );
};

export default CampaignTitleCard;
